import * as React from 'react';
import AppLoader from '../../components/AppLoader';
import { withLoadingContext } from '../../components/AppLoader/Loading';
import RequestQuoteWizard from './RequestQuoteWizard';

const LoadingAwareAuthRequestQuoteApp = withLoadingContext(RequestQuoteWizard);

const App = () => <AppLoader app={LoadingAwareAuthRequestQuoteApp} />;

export default App;
